import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateRenameModalComponent } from './template-rename-modal.component';
import { ButtonModule, InputsModule } from '@xref/xref-lib';
import { LoaderModule } from 'src/app/components/loader/loader.module';

@NgModule({
  declarations: [TemplateRenameModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputsModule,
    LoaderModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [TemplateRenameModalComponent]
})
export class TemplateRenameModalModule { }



